import { render, staticRenderFns } from "./IpfAddItemModal.vue?vue&type=template&id=29154100&scoped=true&"
import script from "./IpfAddItemModal.vue?vue&type=script&lang=ts&"
export * from "./IpfAddItemModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29154100",
  null
  
)

export default component.exports